export const LivePollerWebcastFrequency = 30
export const LivePollerBroadcasterFrequency = 30
export const LivePollerSiteFrequency = 120
export const LivePollerSermonFrequency = 120
